import type { AppError } from "./types";
import { reportError } from "./monitoring";

/**
 * Logs an error with a specified context.
 * This function checks the error's default display mode and log level to determine whether to log it to the console and at what level (error or warning).
 * It also sends the error information to a monitoring service.
 * @param error 
 * @param context 
 * @returns 
 */
export function logError(error: AppError, context?: string): void {

  if (error.defaultDisplayMode === "silent") {
    return;
  }

  const label = context ? `[${context}]` : "";

  const payload = {
    kind: error.kind,
    status: error.status,
    code: error.code,
    traceId: error.traceId,
    message: error.message,
    cause: error.cause,
    meta: error.meta,
  };

  if (error.logLevel === "error") {
    console.error(`AppError${label}`, payload);
  } else {
    console.warn(`AppError${label}`, payload);
  }

  reportError(error, context);
}
